<template>
  <svg
    id="gift_icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_3" data-name="Group 3">
      <path
        id="Path_1404"
        data-name="Path 1404"
        d="M20,8H4A1,1,0,0,0,3,9v2a1,1,0,0,0,1,1H20a1,1,0,0,0,1-1V9A1,1,0,0,0,20,8Z"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd"
      />
      <path
        id="Path_1405"
        data-name="Path 1405"
        d="M12,21V8"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1406"
        data-name="Path 1406"
        d="M15.7,6.612A5.294,5.294,0,0,1,12.1,8"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1407"
        data-name="Path 1407"
        d="M12.1,8s-.494-3.116.721-4.38"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1408"
        data-name="Path 1408"
        d="M15.7,6.612a2.177,2.177,0,0,0,0-2.992,1.978,1.978,0,0,0-2.875,0"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1409"
        data-name="Path 1409"
        d="M8.3,6.612A5.294,5.294,0,0,0,11.9,8"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1410"
        data-name="Path 1410"
        d="M11.9,8s.494-3.116-.721-4.38"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1411"
        data-name="Path 1411"
        d="M8.3,6.612a2.177,2.177,0,0,1,0-2.992,1.978,1.978,0,0,1,2.875,0"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_1412"
        data-name="Path 1412"
        d="M19,12v8a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V12"
        fill="none"
        :stroke="clr"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    clr: {
      default: "#56606b"
    }
  }
};
</script>
